/* eslint-disable import/prefer-default-export */

/**
 * This utility library has also been copied to orderweb; If you make changes
 * here please ensure you duplicate those changes in orderweb too.
 */

export function loadRemoteScript(url, id) {
  return new Promise((resolve, reject) => {
    if (!url) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Roo.url#loadScript: No url argument provided.');
    }

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    if (id) script.setAttribute('id', id);
    script.onload = () => {
      script.onload = null;
      resolve();
    };
    script.onerror = (error) => {
      script.onerror = null;
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`Roo.url#loadScript: ${error.target.src} is not accessible.`);
    };
    document.body.appendChild(script);
  });
}
